export const articleDetail: Record<number, {
  id: number;
  title: string;
  category: string;
  date: string;
  readCount: string;
  author: string;
  imageSeq: string;
  content: string[];
}> = {
  1: {
    id: 1,
    title: '《长安十二时辰》第二季热播，口碑再创新高',
    category: '影视资讯',
    date: '2024-12-15',
    readCount: '12.8万',
    author: '豆花视频编辑部',
    imageSeq: 'article-detail-01',
    content: [
      '备受期待的《长安十二时辰》第二季自开播以来，凭借精良的制作和扣人心弦的剧情，收获观众一致好评。豆瓣评分从开播时的8.9分持续走高，目前稳定在9.2分，成为年度最具话题性的古装剧集之一。',

      '本季延续了第一季的高水准制作，在服化道方面更是精益求精。据制作团队透露，第二季的服装道具制作周期长达八个月，仅主角的服装就设计了超过50套。每一个细节都力求还原唐朝风貌，从服饰纹样到建筑装饰，都经过历史专家的严格考证。',

      '在剧情方面，第二季讲述了全新的悬疑故事。故事背景仍设定在天宝三年上元节前夕的长安城，但这次的危机更加复杂，涉及朝廷内外的多方势力博弈。编剧团队在保留原著精髓的基础上，加入了更多令人意想不到的转折，让观众目不暇接。',

      '演员阵容方面，除了第一季的原班人马悉数回归，还加入了多位实力派演员。主演在接受采访时表示，"第二季的剧本比第一季更加精彩，每个角色都有了更深的挖掘，相信观众会看到不一样的惊喜。"',

      '值得一提的是，本季在视觉效果上也有了质的飞跃。制作团队引入了最新的虚拟拍摄技术，让长安城的繁华景象更加逼真。据悉，仅开篇的长安全景镜头就耗时三个月制作，呈现出了令人叹为观止的盛唐气象。',

      '豆花视频作为本剧的独家网络播出平台，为用户提供了4K超高清画质和杜比全景声的观影体验。会员用户更可享受提前解锁更新、独家幕后花絮等专属权益。目前该剧每周五晚8点更新两集，敬请期待后续精彩剧情。',
    ],
  },
  2: {
    id: 2,
    title: '豆花视频荣获2024年度最佳视频平台奖',
    category: '平台动态',
    date: '2024-12-10',
    readCount: '8.5万',
    author: '豆花视频编辑部',
    imageSeq: 'article-detail-02',
    content: [
      '在刚刚结束的2024中国互联网大会上，豆花视频凭借优质的内容生态和出色的用户体验，荣获"年度最佳视频平台"称号。这是对豆花视频团队多年努力的肯定，也是广大用户对平台认可的最好证明。',

      '中国互联网大会作为国内互联网行业最具影响力的盛会之一，其颁发的年度奖项具有极高的行业权威性。本次评选经过了专家评审、用户投票、数据分析等多个环节的综合评定，豆花视频在各项指标中均名列前茅。',

      '豆花视频CEO在获奖致辞中表示："这个奖项属于每一位豆花视频的用户和团队成员。过去的一年里，我们始终坚持内容为王、用户至上的理念，不断优化产品体验，丰富内容生态。未来我们将继续努力，为用户提供更好的服务。"',

      '过去一年，豆花视频在多个方面取得了显著成绩。在内容方面，平台引进了超过5000部正版影视作品，覆盖电视剧、电影、综艺、动漫、纪录片等多个品类。独家内容数量同比增长超过200%，用户日均观看时长提升了35%。',

      '在技术创新方面，豆花视频自研的AI智能推荐系统获得了多项专利，能够根据用户的观看偏好精准推荐内容。同时，平台还推出了AI智能字幕、画中画播放等创新功能，大大提升了用户体验。',

      '展望未来，豆花视频计划在2025年进一步加大内容投入，预计将投入超过50亿元用于版权采购和自制内容制作。同时，平台还将积极探索AI技术在视频领域的更多应用场景，为用户带来更智能、更便捷的观影体验。',
    ],
  },
  3: {
    id: 3,
    title: '春节档电影即将上线，多部大片等你来看',
    category: '内容预告',
    date: '2024-12-08',
    readCount: '15.2万',
    author: '豆花视频编辑部',
    imageSeq: 'article-detail-03',
    content: [
      '2025年春节档多部重磅电影已确认登陆豆花视频平台。据悉，包括《流浪地球3》、《封神第二部》、《哪吒之魔童闹海》等在内的多部热门大片，将在春节前后陆续上线，为观众献上一场视觉盛宴。',

      '科幻巨制《流浪地球3》作为中国科幻电影的标杆之作，在院线上映期间取得了超过50亿的票房成绩。该片延续了前作的硬核科幻风格，同时在情感表达上更加丰富。豆花视频将提供4K超高清版本，并配有杜比全景声，让用户在家中就能享受影院级的观影体验。',

      '神话史诗系列《封神第二部》在延续第一部宏大世界观的基础上，进一步深入探索了封神演义中那些鲜为人知的精彩故事。影片中令人震撼的特效场景和细腻的人物刻画，使其成为2024年最受好评的华语电影之一。',

      '除了这些已经上映的热门大片，豆花视频还准备了多部独家网络首播的新片。平台已与多家顶级影视制作公司达成战略合作，确保春节档期间每天都有新鲜内容更新。会员用户更可享受提前观影和独家花絮等专属权益。',

      '为了迎接春节档的到来，豆花视频还将推出"春节观影季"主题活动。活动期间，用户可以通过每日签到、观看影片、邀请好友等方式获取会员天数奖励。此外，平台还准备了丰富的周边礼品，参与活动即有机会赢取。',

      '豆花视频内容负责人表示："春节是阖家团圆的时刻，也是观影需求最旺盛的时期。我们精心准备了这份春节片单，希望能够陪伴大家度过一个温馨愉快的假期。无论你喜欢什么类型的影片，都能在豆花视频找到心仪的选择。"',
    ],
  },
  4: {
    id: 4,
    title: '豆花视频APP全新版本发布，体验全面升级',
    category: '产品更新',
    date: '2024-12-05',
    readCount: '6.3万',
    author: '豆花视频产品团队',
    imageSeq: 'article-detail-04',
    content: [
      '豆花视频APP 6.0版本今日正式上线，全新UI设计带来更流畅的交互体验。此次更新是豆花视频自成立以来最大规模的一次产品升级，涵盖了界面设计、功能体验、性能优化等多个方面。',

      '在UI设计方面，6.0版本采用了全新的视觉风格，界面更加简洁清爽。首页布局经过重新设计，内容推荐更加智能化，用户可以在最短时间内找到感兴趣的内容。播放器界面也进行了优化，操作更加便捷直观。',

      '新版本中加入了多项创新功能。AI智能字幕功能支持实时语音识别并生成字幕，让用户即使在静音环境下也能理解视频内容。画中画播放功能则允许用户在看视频的同时进行其他操作，大大提升了多任务使用体验。',

      '针对用户反馈较多的离线缓存问题，6.0版本进行了全面优化。新的智能缓存算法能够根据用户的网络环境和存储空间自动调整缓存策略，在保证画质的同时最大化节省流量和存储空间。下载速度较上一版本提升了40%。',

      '性能方面，APP启动速度提升了30%，视频加载时间减少了25%。团队对底层架构进行了重构，采用更先进的内存管理机制，即使在配置较低的设备上也能流畅运行。电量消耗也较之前版本降低了20%。',

      '豆花视频CTO表示："6.0版本是我们技术积累的一次集中爆发。团队历时八个月完成了这次大版本升级，从底层架构到用户界面都进行了全面重塑。我们相信新版本将给用户带来耳目一新的使用体验。"',
    ],
  },
};